import {
  call, put, takeEvery, all, fork, select,
} from 'redux-saga/effects';
import { api } from '../../helpers/api';
import {
  activeChartSuccess,
  activeChartRequest,
  createChartRequest,
  createChartSuccess,
  modifyChartRequest,
  modifyChartSuccess,
  fetchTestChartDataRequest,
  fetchTestChartDataSuccess,
} from './actions';
import { createToastRequest } from '../toasts/actions';
import {
  refreshRequest,
} from '../auth/actions';
import { ActiveChart } from './constants';
import history from '../../history';

const getAuth = (state) => state.auth?.auth;

const swapEntityIds = (data1) => {
  if (data1 === null || Array.isArray(data1) || !data1 || typeof data1 === 'string' || typeof data1 === 'number' || typeof data1 === 'boolean') return data1;
  const data = { ...data1 };
  if (data?.entityType === "auth-key-with-api" || data?.entityType === "connection-with-api") {
    const temp = data.entityId;
    data.entityId = data.linkedEntityId;
    data.linkedEntityId = temp;
  } else {
    data.linkedEntityId = undefined;
  }
  return data;
};

export function* fetchActiveChart(ops) {
  const { data, callback } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/charts/${data.id}`, 'GET', null, authData.access_token);
      if (response.ok) {
        let parsed = yield response.json();
        parsed = swapEntityIds(parsed);
        yield put(activeChartSuccess(parsed));
      } else if (response.status === 401) {
        yield put(refreshRequest(activeChartRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* createChart(ops) {
  const { data: dataBase, callback } = ops;
  const authData = yield select(getAuth);
  const data = swapEntityIds(dataBase);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/charts`, 'POST', data, authData.access_token);
      if (response.ok) {
        let parsed = yield response.json();
        parsed = swapEntityIds(parsed);
        if (callback) callback();
        yield put(createChartSuccess(parsed));
        yield put(createToastRequest({ type: 'success', title: data.name, text: 'chart has been created successfully' }));
      } else if (response.status === 401) {
        yield put(refreshRequest(createChartRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* modifyChart(ops) {
  const { data: dataBase, callback } = ops;
  const authData = yield select(getAuth);
  const data = swapEntityIds(dataBase);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/charts/${data.id}`, 'PUT', data, authData.access_token);
      if (response.ok) {
        let parsed = yield response.json();
        parsed = swapEntityIds(parsed);
        if (callback) callback();
        yield put(modifyChartSuccess(parsed));
        yield put(createToastRequest({ type: 'success', title: data.name, text: 'chart was updated' }));
      } else if (response.status === 401) {
        yield put(refreshRequest(modifyChartRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* fetchTestChartData(ops) {
  const { data: dataDraft, callback } = ops;
  const data = swapEntityIds(dataDraft);
  const { range, interval, group, entityType, entityId, linkedEntityId, timezoneOffset } = data;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/charts/collect?range=${range}&interval=${interval}&group=${group?.join(',')}&entityType=${entityType}&entityId=${entityId}&timezoneOffset=${timezoneOffset}${linkedEntityId ? `&linkedEntityId=${linkedEntityId}` : ''}`, 'GET', null, authData.access_token);
      if (response.ok) {
        let parsed = yield response.json();
        if (callback) callback();
        parsed = swapEntityIds(parsed);
        yield put(fetchTestChartDataSuccess(parsed));
      } else if (response.status === 401) {
        yield put(refreshRequest(fetchTestChartDataRequest, data, callback));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

function* activeChartSaga() {
  yield takeEvery(ActiveChart.activeChartRequest, fetchActiveChart);
  yield takeEvery(ActiveChart.createChartRequest, createChart);
  yield takeEvery(ActiveChart.modifyChartRequest, modifyChart);
  yield takeEvery(ActiveChart.fetchTestChartDataRequest, fetchTestChartData);
}

function* configSaga() {
  yield all([fork(activeChartSaga)]);
}

export default configSaga;
